import React from 'react'
import { Skeleton, Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { AppTableSeeker } from "@components"

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { dateColumn, deliveryInfoColumn, actionColumn, retailerColumn, productNameColumn } from './columns'
import {useAmazonReleaseDateFilters} from "../@hooks";
import CreateReportButton from "./actions/CreateReportButton";

export default function AmazonReleaseDateTable() {

	const { data } = useAmazonReleaseDateFilters()
	const { showToast } = useToast()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
	if (!data.length) return <></>

	const columns = [
		...retailerColumn(),
		...productNameColumn(),
		dateColumn('streetDate', 'Salsify Street Date'),
		dateColumn('releaseDate', 'Release Date'),
		deliveryInfoColumn(),
		...actionColumn()
	]

	return <AppTableSeeker
		data={data}
		title={<Box sx={{ display: 'flex', alignItems:'center', justifyContent:'start', gap: 1 }} ><IconSeeker icon="clock" iconWeight='thin' />Amazon Release Date</Box>}
		columns={columns}
		options={{
			tableBodyHeight: '700',
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/custom-dash/amazon-release-date/excel`),
			customToolbar: () => <CreateReportButton />,
			viewColumns: false,
		}}
	/>
}